<template>
    <model-modal
        component="v-spa-mixed-modal"
        :model-class="modelClass" 
        modal-type="form"
        @opening="onOpening"
        @opened="onOpened"
        @resetted="onReset"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <h2 class="mb-4 text-xl">
                {{ slotProps.model ? $t('worksite.files.folder_form.edit_title') : $t('worksite.files.folder_form.title') }}
            </h2>
            <form @submit.prevent="submit">
                <v-spa-input ref="inputTitle" id="create-folder-form-title" :form="form" input-name="title"></v-spa-input>
                <div class="flex justify-end max-w-input">
                    <v-spa-loading-button :loading="form.isLoading()">
                        {{ slotProps.model ? $t('worksite.files.folder_form.edit_button') : $t('worksite.files.folder_form.button') }}
                    </v-spa-loading-button>
                </div>
            </form>
        </template>
    </model-modal>
</template>

<script>
    import Form from '~spa/classes/Form';
    import DatePicker from 'v-calendar/lib/components/date-picker.umd';
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import WorksiteFileFolder from '@spa/apps/trustup-pro-worksite-js/models/WorksiteFileFolder';

    export default {
        components: {
            ModelModal,
            DatePicker,
        },
        
        data() {
            return {
                modelClass: WorksiteFileFolder,
                worksite: null,
                currentFolder: null,
                form: new Form({
                    title: ''
                })
            }
        },

        methods: {
            async onOpening(data)
            {
                if ( this.$refs.modal.model ) {
                    this.form.title = this.$refs.modal.model.title;
                }

                this.worksite = data.worksite;
                this.currentFolder = data.currentFolder;
            },

            async onOpened()
            {
                await this.$nextTick();
                await this.$nextTick();
                this.$refs.inputTitle.$refs.input.focus();
            },

            onReset()
            {
                this.form.reset();
                this.form.stop();
                this.worksite = null;
                this.currentFolder = null;
            },

            async submit()
            {
                if ( this.form.isLoading() ) {
                    return;
                }
                
                this.form.load();
                let data = this.form.data();
                data.folder = this.currentFolder;
                let action = this.$refs.modal.model ? 'update' : 'store';
                let params = this.$refs.modal.model ? {uuid: this.$refs.modal.model.uuid, data: data} : data;

                await window.Worksite.endpoints.worksiteFileFolder.setWorksite(this.worksite)[action](params);
                this.$refs.modal.close();
            },
        }
    }
</script>